const sectionId = window.brandCollectionsectionId;
document.addEventListener("DOMContentLoaded", (event) => {
  const swiper = new Swiper(`.swiper-brand-collection-${sectionId}`, {
    // Optional parameters
    slidesPerView: 'auto',
    spaceBetween: 10,
    // freeMode: true,
    navigation: {
      nextEl: `.brand-collection-next-${sectionId}.swiper-button-next`,
      prevEl: `.brand-collection-prev-${sectionId}.swiper-button-prev`,
    },
    // If we need pagination
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    // Responsive breakpoints
    breakpoints: {
      // when window width is >= 320px
      350: {
        slidesPerView: 'auto',
        spaceBetween: 10,
      },
      // when window width is >= 640px
      640: {
        slidesPerView: 'auto',
        spaceBetween: 30,
      },
      // when window width is >= 767px
      767: {
        slidesPerView: 'auto',
        spaceBetween: 32,
      },
      // when window width is >= 1199px
      1199: {
        slidesPerView: 7,
        spaceBetween: 32,
      },
    },
    on: {
      init: function () {
        const swiperContainer = document.querySelector(
          `.swiper-brand-collection-${sectionId}`
        );
        swiperContainer.style.opacity = 1;
        swiperContainer.style.visibility = "visible";
      },
    },
  });

  const links = document.querySelectorAll(".brand-collection-link");

  links.forEach((link) => {
    link.addEventListener("click", function (event) {
      event.preventDefault();
      const targetId = this.getAttribute("href").substring(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth" });
      }
    });
  });
});
